
import { gql } from '@apollo/client';

export const CREATE_BILL_INVOICE = gql`
  mutation CreateBillInvoice($input: CreateBillInvoiceInput!) {
    createBillInvoice(input: $input) {
      success
      errorMessage
    }
  }
`;

export const CANCEL_BILL_INVOICE = gql`
  mutation CancelBillInvoice($input: CancelBillInvoiceInput!) {
    cancelBillInvoice(input: $input) {
      success
      errorMessage
    }
  }
`;
